// routes
import { PATH_DASHBOARD, PATH_PAGE, PATH_ROOT } from './routes/paths';

// Beacon UUID
export const BEACON_UUID = '01122334-4556-5778-899A-ABBCCDDEEFF0';

// ROLES
export const ROLE_NAMES = {
  root: 'root',
  admin: 'admin',
  manager: 'manager',
  staff: 'staff',
  all: '*',
};

// PERMISSIONS
export const PERMISSION_NAMES = {
  // Activity
  alert: 'alert',

  // Work
  checklist: 'checklist',
  device: 'device',
  location: 'location',
  mobile: 'mobile',
  place: 'place',
  schedule: 'schedule',

  // User
  group: 'group',
  role: 'role',
  user: 'user',

  // Statistic
  dashboard: 'dashboard',
  report: 'report',
  company: 'company',

  // All
  all: '*',
};

// Method names
export const METHOD_NAMES = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
};

export const BUSINESS_OPTIONS = [
  'createcompany.business_type.factory',
  'createcompany.business_type.hospital',
  'createcompany.business_type.building_operation',
  'createcompany.business_type.security',
  'createcompany.business_type.cleaning',
  'createcompany.business_type.technology',
  'createcompany.business_type.transportation',
  'createcompany.business_type.others',
];

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || '';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.activitie; // as '/dashboard/app'

export const PATH_AFTER_LOGIN_AS_ROOT = PATH_ROOT.general.app; // as '/root/app'

export const PATH_CREATE_COMPANY = PATH_PAGE.createCompany;
// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  // Khi scroll
  DASHBOARD_DESKTOP_HEIGHT: 92 - 16,
  // Khi ở top
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'default',
  themeLayout: 'horizontal',
  themeStretch: false,
};
